// extracted by mini-css-extract-plugin
export default {"input":"Checkbox_input__R0XSa","label":"Checkbox_label__fgyNp"};